var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull", attrs: { id: "site-nav" } }, [
    _c("div", { staticClass: "container widthFull" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-6 col-md-6 pt-1 pb-1" }, [
          _c("ul", { staticClass: "navbar-nav m-auto mb-lg-0 mb-md-5" }, [
            _c(
              "li",
              {
                staticClass: "nav-item",
                attrs: {
                  "data-toggle": "collapse",
                  "data-target": ".navbar-collapse.show"
                }
              },
              [
                _c(
                  "router-link",
                  {
                    directives: [
                      {
                        name: "scroll-to",
                        rawName: "v-scroll-to",
                        value: ".main",
                        expression: "'.main'"
                      }
                    ],
                    staticClass: "nav-link",
                    attrs: {
                      to: "/",
                      "data-toggle": "collapse",
                      "data-target": ".navbar-collapse.show"
                    }
                  },
                  [
                    _c("span", { staticClass: "menuItem Bold" }, [
                      _vm.brand == "CHEBONUS"
                        ? _c("b", { staticClass: "Bold" }, [_vm._v("CheBonus")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c("b", { staticClass: "Bold" }, [
                            _vm._v("HappyBonus")
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 col-md-6 pt-1 pb-1" }, [
          _c(
            "ul",
            { staticClass: "navbar-nav d-block  mb-lg-0 mb-md-5 text-right " },
            [
              _vm.isProfileLoaded
                ? _c(
                    "li",
                    {
                      staticClass:
                        "nav-item dropdown mr-0 pd-0 custNavWidth float-right"
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "nav-link dropdown-toggle menuItem mr-0 pd-0",
                          attrs: {
                            href: "#",
                            id: "navbardrop",
                            "data-toggle": "dropdown"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "pointer mr-0 pd-0",
                            attrs: { icon: "user", size: "1x" }
                          }),
                          _vm._v(" "),
                          _vm.vw > 500 ? [_vm._v(" Gestione ")] : _vm._e(),
                          _vm._v(" Profilo "),
                          _vm.vw > 500 ? [_vm._v("aderente")] : _vm._e(),
                          _vm._v(" e FAQ\n        ")
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu bgDrop",
                          attrs: {
                            "data-toggle": "collapse ",
                            "data-target": ".navbar-collapse.show"
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              directives: [
                                {
                                  name: "scroll-to",
                                  rawName: "v-scroll-to",
                                  value: ".main",
                                  expression: "'.main'"
                                }
                              ],
                              staticClass: "dropdown-item menuItem ",
                              attrs: {
                                to: "/account",
                                "data-toggle": "collapse",
                                "data-target": ".navbar-collapse.show"
                              }
                            },
                            [
                              _c("span", { staticClass: "menuItem ipadMenu" }, [
                                _vm._v("Modifica Profilo aderente")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "dropdown-item pointer menuItem black",
                              on: { click: _vm.logout }
                            },
                            [
                              _c("span", { staticClass: "menuItem ipadMenu" }, [
                                _vm._v("Esci")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isProfileLoaded
                ? _c(
                    "li",
                    {
                      staticClass: "nav-item ",
                      attrs: {
                        "data-toggle": "collapse",
                        "data-target": ".navbar-collapse.show"
                      }
                    },
                    [
                      _c(
                        "router-link",
                        { staticClass: "nav-link", attrs: { to: "/login" } },
                        [
                          _c("span", { staticClass: "menuItem " }, [
                            _vm._v("Registrati/Accedi")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "nav",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.menuOFF,
            expression: "!menuOFF"
          }
        ],
        staticClass: "navbar navbar-light  navbar-expand-lg bgWhite ",
        class: { "fixed-top": _vm.scroll > 48 },
        staticStyle: { "z-index": "11" }
      },
      [
        _c("div", { staticClass: "container widthFull center" }, [
          _c(
            "div",
            { staticClass: "navbar-header " },
            [
              _c(
                "router-link",
                {
                  staticClass:
                    "navbar-brand router-link-exact-active router-link-active",
                  attrs: { to: "/" }
                },
                [
                  _vm.brand == "CHEBONUS"
                    ? _c("img", {
                        ref: "mainNavLogo",
                        staticClass: "img-fluid logo ml-0",
                        attrs: {
                          src: require("../../assets/images/vaillant-logo.png"),
                          alt: ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.brand == "HAPPYBONUS"
                    ? _c("img", {
                        ref: "mainNavLogo",
                        staticClass: "img-fluid logo ml-0",
                        attrs: {
                          src: require("../../assets/images/hsd-logo.png"),
                          alt: ""
                        }
                      })
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "  navbar-toggler navbar-toggler-right align-self-center navbar-toggle collapsed",
                  class: { btnBurgrHSDRed: _vm.brand == "HAPPYBONUS" },
                  attrs: {
                    type: "button",
                    "data-toggle": "collapse",
                    "data-target": "#navbarCollapse",
                    "aria-expanded": "false"
                  }
                },
                [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v("Toggle navigation")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "icon-bar top-bar" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "icon-bar middle-bar" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "icon-bar bottom-bar" })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "collapse navbar-collapse flex-column ml-0 pl-3",
              attrs: { id: "navbarCollapse" }
            },
            [
              _c("ul", { staticClass: "navbar-nav mr-auto mb-lg-0 mb-5" }, [
                _vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/flowSettings" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "menuItem Bold" },
                              [
                                _vm._v(
                                  "\n                    Gestione Prerequisiti Cessione\n                    "
                                ),
                                _vm.getProfile.cdp_expired_at
                                  ? [
                                      _vm.moment().add(10, "days") >
                                      _vm.moment(_vm.getProfile.cdp_expired_at)
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "badge badge-danger"
                                            },
                                            [_vm._v("!")]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/calcolatore" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Crea nuovo Preventivo")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/offerte" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Gestione Preventivi")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/pratiche" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Gestione Pratiche")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/cessioni" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Gestione Cessioni")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isProfileLoaded
                  ? _c("li", { staticClass: "nav-item" }, [
                      _vm.brand == "CHEBONUS"
                        ? _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                href:
                                  "https://www.vaillant.it/professionisti/prodotti/che-bonus/",
                                target: "_blank"
                              }
                            },
                            [
                              _c("span", { staticClass: "menuItem Bold" }, [
                                _vm._v("Scopri CheBonus")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              attrs: {
                                href:
                                  "https://www.hermann-saunierduval.it/per-il-professionista/happy-bonus/",
                                target: "_blank"
                              }
                            },
                            [
                              _c("span", { staticClass: "menuItem Bold" }, [
                                _vm._v("Scopri HappyBonus")
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/cessioni" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Area riservata aderente")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/registration" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Registrati")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "notificationContent",
              class: { notificationC: _vm.showNotification }
            },
            [
              _c(
                "div",
                { staticClass: "container relative pb-5 maxNotification" },
                [
                  _c(
                    "div",
                    { staticClass: "row justify-content-center widthFull" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-8 pl-5 pb-2 pt-4 pb-4 reverse" },
                        [
                          _vm._l(_vm.notifications, function(item, index) {
                            return _c(
                              "div",
                              {
                                staticClass:
                                  "row justify-content-center widthFull "
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-md-11 pl-5 mb-2",
                                    class: {
                                      errorBg: item.type == "ERROR",
                                      successBg: item.type == "SUCCESS"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(parseInt(index) + 1) +
                                        ") "
                                    ),
                                    _c("span", {
                                      domProps: { innerHTML: _vm._s(item.text) }
                                    })
                                  ]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.countNotification == 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "row justify-content-center widthFull"
                                },
                                [_vm._m(1)]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }),
    _vm._v(" "),
    _vm.vw > 767 && _vm.isProfileLoaded
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.menuOFF,
                expression: "!menuOFF"
              },
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.outside2,
                expression: "outside2"
              }
            ],
            staticClass: "sidetab",
            class: {
              "sidebar-opened": _vm.toggleTabState == "open",
              "sidebar-closed": _vm.toggleTabState == "close",
              tabMobile: _vm.vw < 533,
              sidetabHSD: _vm.brand == "HAPPYBONUS"
            }
          },
          [
            _c("div", { staticClass: "label", on: { click: _vm.toggleTab } }, [
              _vm.vw < 533
                ? _c("img", {
                    staticClass: "img-fluid contactImg",
                    attrs: { src: require("../../assets/images/contact2.png") }
                  })
                : _c("span", [
                    _c("img", {
                      staticClass: "leftIm",
                      class: { posWA: _vm.toggleTabState != "close" },
                      attrs: { src: require("../../assets/images/wa.png") }
                    }),
                    _vm._v("\n        Per assistenza\n        "),
                    _c("img", {
                      staticClass: "rightIm",
                      class: { posTEL: _vm.toggleTabState != "close" },
                      attrs: { src: require("../../assets/images/tel.png") }
                    })
                  ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "inner-content" }, [
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "media chat-available voice-available video-available"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "media-label",
                        staticStyle: {
                          "padding-top": "5px",
                          "font-size": "12px",
                          "font-weight": "bold",
                          color: "rgba(0, 0, 0, 0.54)"
                        }
                      },
                      [
                        _vm._v("\n\n            Chiama il numero "),
                        _c("span", {
                          staticClass: "black",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.brand == "CHEBONUS"
                                ? _vm.phone
                                : _vm.phone_hsd
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v("o invia WhatsApp a "),
                        _c(
                          "span",
                          {
                            staticClass: "green",
                            class: { redHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("b", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.brand == "CHEBONUS"
                                    ? _vm.phone
                                    : _vm.phone_hsd
                                )
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v("oppure scrivi a:\n            "),
                        _c("br"),
                        _c("a", {
                          staticClass: "black",
                          attrs: {
                            href:
                              "mailto:" +
                              (_vm.brand == "CHEBONUS"
                                ? _vm.email
                                : _vm.email_hsd)
                          },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.brand == "CHEBONUS"
                                ? _vm.email
                                : _vm.email_hsd
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v("dal lunedì al venerdì\n            "),
                        _c("br"),
                        _vm._v("dalle 09:00-13:00 e 14:00-18:00\n            "),
                        _c("br"),
                        _vm._v("esclusi i giorni festivi\n            "),
                        _c("br"),
                        _c("br")
                      ]
                    )
                  ]
                )
              ])
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.acceptCookies
      ? _c(
          "div",
          {
            staticClass: "container-fluid fixed cookieBaner",
            class: { redHSDBack: _vm.brand == "HAPPYBONUS" }
          },
          [
            _c("div", { staticClass: "row justify-content-center widthFull" }, [
              _vm._m(3),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-sm-2 center col-md-2 col-lg-2 mt-sm-5 pt-3 pt-md-2 mt-md-3"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary btn-lg yellowBtn mb-5 pr-3 pl-3",
                      class: { btnYellow: _vm.brand == "HAPPYBONUS" },
                      on: { click: _vm.doAcceptCookies }
                    },
                    [_vm._v(" OK")]
                  )
                ]
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 pl-5 pb-2" }, [
      _c("h2", { staticClass: "black widthFull pb-0 mb-1" }, [
        _c("b", { staticClass: "widthFull" }, [_vm._v("Notifiche")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "widthFull" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center pl-5 " }, [
      _c("h5", {}, [_c("b", [_vm._v("Non hai nessuna notifica")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-message" }, [
      _c("strong", [_vm._v("Hai bisogno di assistenza?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-sm-10 col-md-9 col-lg-6 pt-sm-0 pt-md-3" },
      [
        _c("span", { staticClass: "cookieText" }, [
          _vm._v(
            "\n          Utilizziamo i cookie al fine di personalizzare e migliorare la tua esperienza sul nostro sito.\n          Visita la nostra "
          ),
          _c(
            "a",
            {
              staticStyle: {
                color: "#f39324!important",
                "text-decoration": "underline"
              },
              attrs: { target: "_blank", href: "informativa.pdf" }
            },
            [_vm._v("informativa")]
          ),
          _vm._v(
            " per acquisire maggiori informazioni.\n          Utilizzando il nostro sito accetti l'utilizzo dei cookie da parte nostra.\n        "
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eacecb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eacecb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/index.vue
// module id = null
// module chunks = 